(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("5jxwZ", function(module, exports) {

$parcel$export(module.exports, "HelmetProvider", function () { return $3de8bcaad58a651a$export$4719288a8f5f7e71; });
$parcel$export(module.exports, "Helmet", function () { return $3de8bcaad58a651a$export$dcef8f9bb9a41431; });

var $dTCkE = parcelRequire("dTCkE");

var $34sMR = parcelRequire("34sMR");

var $lyBMc = parcelRequire("lyBMc");

var $gQQaU = parcelRequire("gQQaU");

var $agBrw = parcelRequire("agBrw");
function $3de8bcaad58a651a$var$a() {
    return $3de8bcaad58a651a$var$a = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var r = arguments[e];
            for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
        }
        return t;
    }, $3de8bcaad58a651a$var$a.apply(this, arguments);
}
function $3de8bcaad58a651a$var$s(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, $3de8bcaad58a651a$var$c(t, e);
}
function $3de8bcaad58a651a$var$c(t, e) {
    return $3de8bcaad58a651a$var$c = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    }, $3de8bcaad58a651a$var$c(t, e);
}
function $3de8bcaad58a651a$var$u(t, e) {
    if (null == t) return {};
    var r, n, i = {}, o = Object.keys(t);
    for(n = 0; n < o.length; n++)e.indexOf(r = o[n]) >= 0 || (i[r] = t[r]);
    return i;
}
var $3de8bcaad58a651a$var$l = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title",
    FRAGMENT: "Symbol(react.fragment)"
}, $3de8bcaad58a651a$var$p = {
    rel: [
        "amphtml",
        "canonical",
        "alternate"
    ]
}, $3de8bcaad58a651a$var$f = {
    type: [
        "application/ld+json"
    ]
}, $3de8bcaad58a651a$var$d = {
    charset: "",
    name: [
        "robots",
        "description"
    ],
    property: [
        "og:type",
        "og:title",
        "og:url",
        "og:image",
        "og:image:alt",
        "og:description",
        "twitter:url",
        "twitter:title",
        "twitter:description",
        "twitter:image",
        "twitter:image:alt",
        "twitter:card",
        "twitter:site"
    ]
}, $3de8bcaad58a651a$var$h = Object.keys($3de8bcaad58a651a$var$l).map(function(t) {
    return $3de8bcaad58a651a$var$l[t];
}), $3de8bcaad58a651a$var$m = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
}, $3de8bcaad58a651a$var$y = Object.keys($3de8bcaad58a651a$var$m).reduce(function(t, e) {
    return t[$3de8bcaad58a651a$var$m[e]] = e, t;
}, {}), $3de8bcaad58a651a$var$T = function(t, e) {
    for(var r = t.length - 1; r >= 0; r -= 1){
        var n = t[r];
        if (Object.prototype.hasOwnProperty.call(n, e)) return n[e];
    }
    return null;
}, $3de8bcaad58a651a$var$g = function(t) {
    var e = $3de8bcaad58a651a$var$T(t, $3de8bcaad58a651a$var$l.TITLE), r = $3de8bcaad58a651a$var$T(t, "titleTemplate");
    if (Array.isArray(e) && (e = e.join("")), r && e) return r.replace(/%s/g, function() {
        return e;
    });
    var n = $3de8bcaad58a651a$var$T(t, "defaultTitle");
    return e || n || void 0;
}, $3de8bcaad58a651a$var$b = function(t) {
    return $3de8bcaad58a651a$var$T(t, "onChangeClientState") || function() {};
}, $3de8bcaad58a651a$var$v = function(t, e) {
    return e.filter(function(e) {
        return void 0 !== e[t];
    }).map(function(e) {
        return e[t];
    }).reduce(function(t, e) {
        return $3de8bcaad58a651a$var$a({}, t, e);
    }, {});
}, $3de8bcaad58a651a$var$A = function(t, e) {
    return e.filter(function(t) {
        return void 0 !== t[$3de8bcaad58a651a$var$l.BASE];
    }).map(function(t) {
        return t[$3de8bcaad58a651a$var$l.BASE];
    }).reverse().reduce(function(e, r) {
        if (!e.length) for(var n = Object.keys(r), i = 0; i < n.length; i += 1){
            var o = n[i].toLowerCase();
            if (-1 !== t.indexOf(o) && r[o]) return e.concat(r);
        }
        return e;
    }, []);
}, $3de8bcaad58a651a$var$C = function(t, e, r) {
    var n = {};
    return r.filter(function(e) {
        return !!Array.isArray(e[t]) || (void 0 !== e[t] && console && "function" == typeof console.warn && console.warn("Helmet: " + t + ' should be of type "Array". Instead found type "' + typeof e[t] + '"'), !1);
    }).map(function(e) {
        return e[t];
    }).reverse().reduce(function(t, r) {
        var i = {};
        r.filter(function(t) {
            for(var r, o = Object.keys(t), a = 0; a < o.length; a += 1){
                var s = o[a], c = s.toLowerCase();
                -1 === e.indexOf(c) || "rel" === r && "canonical" === t[r].toLowerCase() || "rel" === c && "stylesheet" === t[c].toLowerCase() || (r = c), -1 === e.indexOf(s) || "innerHTML" !== s && "cssText" !== s && "itemprop" !== s || (r = s);
            }
            if (!r || !t[r]) return !1;
            var u = t[r].toLowerCase();
            return n[r] || (n[r] = {}), i[r] || (i[r] = {}), !n[r][u] && (i[r][u] = !0, !0);
        }).reverse().forEach(function(e) {
            return t.push(e);
        });
        for(var o = Object.keys(i), s = 0; s < o.length; s += 1){
            var c = o[s], u = $3de8bcaad58a651a$var$a({}, n[c], i[c]);
            n[c] = u;
        }
        return t;
    }, []).reverse();
}, $3de8bcaad58a651a$var$O = function(t, e) {
    if (Array.isArray(t) && t.length) {
        for(var r = 0; r < t.length; r += 1)if (t[r][e]) return !0;
    }
    return !1;
}, $3de8bcaad58a651a$var$S = function(t) {
    return Array.isArray(t) ? t.join("") : t;
}, $3de8bcaad58a651a$var$E = function(t, e) {
    return Array.isArray(t) ? t.reduce(function(t, r) {
        return function(t, e) {
            for(var r = Object.keys(t), n = 0; n < r.length; n += 1)if (e[r[n]] && e[r[n]].includes(t[r[n]])) return !0;
            return !1;
        }(r, e) ? t.priority.push(r) : t.default.push(r), t;
    }, {
        priority: [],
        default: []
    }) : {
        default: t
    };
}, $3de8bcaad58a651a$var$I = function(t, e) {
    var r;
    return $3de8bcaad58a651a$var$a({}, t, ((r = {})[e] = void 0, r));
}, $3de8bcaad58a651a$var$P = [
    $3de8bcaad58a651a$var$l.NOSCRIPT,
    $3de8bcaad58a651a$var$l.SCRIPT,
    $3de8bcaad58a651a$var$l.STYLE
], $3de8bcaad58a651a$var$w = function(t, e) {
    return void 0 === e && (e = !0), !1 === e ? String(t) : String(t).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}, $3de8bcaad58a651a$var$x = function(t) {
    return Object.keys(t).reduce(function(e, r) {
        var n = void 0 !== t[r] ? r + '="' + t[r] + '"' : "" + r;
        return e ? e + " " + n : n;
    }, "");
}, $3de8bcaad58a651a$var$L = function(t, e) {
    return void 0 === e && (e = {}), Object.keys(t).reduce(function(e, r) {
        return e[$3de8bcaad58a651a$var$m[r] || r] = t[r], e;
    }, e);
}, $3de8bcaad58a651a$var$j = function(e, r) {
    return r.map(function(r, n) {
        var i, o = ((i = {
            key: n
        })["data-rh"] = !0, i);
        return Object.keys(r).forEach(function(t) {
            var e = $3de8bcaad58a651a$var$m[t] || t;
            "innerHTML" === e || "cssText" === e ? o.dangerouslySetInnerHTML = {
                __html: r.innerHTML || r.cssText
            } : o[e] = r[t];
        }), (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).createElement(e, o);
    });
}, $3de8bcaad58a651a$var$M = function(e, r, n) {
    switch(e){
        case $3de8bcaad58a651a$var$l.TITLE:
            return {
                toComponent: function() {
                    var e, n, i, o;
                    return n = r.titleAttributes, (i = {
                        key: e = r.title
                    })["data-rh"] = !0, o = $3de8bcaad58a651a$var$L(n, i), [
                        (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).createElement($3de8bcaad58a651a$var$l.TITLE, o, e)
                    ];
                },
                toString: function() {
                    return function(t, e, r, n) {
                        var i = $3de8bcaad58a651a$var$x(r), o = $3de8bcaad58a651a$var$S(e);
                        return i ? "<" + t + ' data-rh="true" ' + i + ">" + $3de8bcaad58a651a$var$w(o, n) + "</" + t + ">" : "<" + t + ' data-rh="true">' + $3de8bcaad58a651a$var$w(o, n) + "</" + t + ">";
                    }(e, r.title, r.titleAttributes, n);
                }
            };
        case "bodyAttributes":
        case "htmlAttributes":
            return {
                toComponent: function() {
                    return $3de8bcaad58a651a$var$L(r);
                },
                toString: function() {
                    return $3de8bcaad58a651a$var$x(r);
                }
            };
        default:
            return {
                toComponent: function() {
                    return $3de8bcaad58a651a$var$j(e, r);
                },
                toString: function() {
                    return function(t, e, r) {
                        return e.reduce(function(e, n) {
                            var i = Object.keys(n).filter(function(t) {
                                return !("innerHTML" === t || "cssText" === t);
                            }).reduce(function(t, e) {
                                var i = void 0 === n[e] ? e : e + '="' + $3de8bcaad58a651a$var$w(n[e], r) + '"';
                                return t ? t + " " + i : i;
                            }, ""), o = n.innerHTML || n.cssText || "", a = -1 === $3de8bcaad58a651a$var$P.indexOf(t);
                            return e + "<" + t + ' data-rh="true" ' + i + (a ? "/>" : ">" + o + "</" + t + ">");
                        }, "");
                    }(e, r, n);
                }
            };
    }
}, $3de8bcaad58a651a$var$k = function(t) {
    var e = t.baseTag, r = t.bodyAttributes, n = t.encode, i = t.htmlAttributes, o = t.noscriptTags, a = t.styleTags, s = t.title, c = void 0 === s ? "" : s, u = t.titleAttributes, h = t.linkTags, m = t.metaTags, y = t.scriptTags, T = {
        toComponent: function() {},
        toString: function() {
            return "";
        }
    };
    if (t.prioritizeSeoTags) {
        var g = function(t) {
            var e = t.linkTags, r = t.scriptTags, n = t.encode, i = $3de8bcaad58a651a$var$E(t.metaTags, $3de8bcaad58a651a$var$d), o = $3de8bcaad58a651a$var$E(e, $3de8bcaad58a651a$var$p), a = $3de8bcaad58a651a$var$E(r, $3de8bcaad58a651a$var$f);
            return {
                priorityMethods: {
                    toComponent: function() {
                        return [].concat($3de8bcaad58a651a$var$j($3de8bcaad58a651a$var$l.META, i.priority), $3de8bcaad58a651a$var$j($3de8bcaad58a651a$var$l.LINK, o.priority), $3de8bcaad58a651a$var$j($3de8bcaad58a651a$var$l.SCRIPT, a.priority));
                    },
                    toString: function() {
                        return $3de8bcaad58a651a$var$M($3de8bcaad58a651a$var$l.META, i.priority, n) + " " + $3de8bcaad58a651a$var$M($3de8bcaad58a651a$var$l.LINK, o.priority, n) + " " + $3de8bcaad58a651a$var$M($3de8bcaad58a651a$var$l.SCRIPT, a.priority, n);
                    }
                },
                metaTags: i.default,
                linkTags: o.default,
                scriptTags: a.default
            };
        }(t);
        T = g.priorityMethods, h = g.linkTags, m = g.metaTags, y = g.scriptTags;
    }
    return {
        priority: T,
        base: $3de8bcaad58a651a$var$M($3de8bcaad58a651a$var$l.BASE, e, n),
        bodyAttributes: $3de8bcaad58a651a$var$M("bodyAttributes", r, n),
        htmlAttributes: $3de8bcaad58a651a$var$M("htmlAttributes", i, n),
        link: $3de8bcaad58a651a$var$M($3de8bcaad58a651a$var$l.LINK, h, n),
        meta: $3de8bcaad58a651a$var$M($3de8bcaad58a651a$var$l.META, m, n),
        noscript: $3de8bcaad58a651a$var$M($3de8bcaad58a651a$var$l.NOSCRIPT, o, n),
        script: $3de8bcaad58a651a$var$M($3de8bcaad58a651a$var$l.SCRIPT, y, n),
        style: $3de8bcaad58a651a$var$M($3de8bcaad58a651a$var$l.STYLE, a, n),
        title: $3de8bcaad58a651a$var$M($3de8bcaad58a651a$var$l.TITLE, {
            title: c,
            titleAttributes: u
        }, n)
    };
}, $3de8bcaad58a651a$var$H = [], $3de8bcaad58a651a$export$a9cf6990c9c7feb9 = function(t, e) {
    var r = this;
    void 0 === e && (e = "undefined" != typeof document), this.instances = [], this.value = {
        setHelmet: function(t) {
            r.context.helmet = t;
        },
        helmetInstances: {
            get: function() {
                return r.canUseDOM ? $3de8bcaad58a651a$var$H : r.instances;
            },
            add: function(t) {
                (r.canUseDOM ? $3de8bcaad58a651a$var$H : r.instances).push(t);
            },
            remove: function(t) {
                var e = (r.canUseDOM ? $3de8bcaad58a651a$var$H : r.instances).indexOf(t);
                (r.canUseDOM ? $3de8bcaad58a651a$var$H : r.instances).splice(e, 1);
            }
        }
    }, this.context = t, this.canUseDOM = e, e || (t.helmet = $3de8bcaad58a651a$var$k({
        baseTag: [],
        bodyAttributes: {},
        encodeSpecialCharacters: !0,
        htmlAttributes: {},
        linkTags: [],
        metaTags: [],
        noscriptTags: [],
        scriptTags: [],
        styleTags: [],
        title: "",
        titleAttributes: {}
    }));
}, $3de8bcaad58a651a$var$R = (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).createContext({}), $3de8bcaad58a651a$var$D = (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).shape({
    setHelmet: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).func,
    helmetInstances: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).shape({
        get: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).func,
        add: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).func,
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).func
    })
}), $3de8bcaad58a651a$var$U = "undefined" != typeof document, $3de8bcaad58a651a$export$4719288a8f5f7e71 = /*#__PURE__*/ function(e) {
    function r(t) {
        var n;
        return (n = e.call(this, t) || this).helmetData = new $3de8bcaad58a651a$export$a9cf6990c9c7feb9(n.props.context, r.canUseDOM), n;
    }
    return $3de8bcaad58a651a$var$s(r, e), r.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).createElement($3de8bcaad58a651a$var$R.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }, r;
}((0, $dTCkE.Component));
$3de8bcaad58a651a$export$4719288a8f5f7e71.canUseDOM = $3de8bcaad58a651a$var$U, $3de8bcaad58a651a$export$4719288a8f5f7e71.propTypes = {
    context: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).shape({
        helmet: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).shape()
    }),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).node.isRequired
}, $3de8bcaad58a651a$export$4719288a8f5f7e71.defaultProps = {
    context: {}
}, $3de8bcaad58a651a$export$4719288a8f5f7e71.displayName = "HelmetProvider";
var $3de8bcaad58a651a$var$Y = function(t, e) {
    var r, n = document.head || document.querySelector($3de8bcaad58a651a$var$l.HEAD), i = n.querySelectorAll(t + "[data-rh]"), o = [].slice.call(i), a = [];
    return e && e.length && e.forEach(function(e) {
        var n = document.createElement(t);
        for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && ("innerHTML" === i ? n.innerHTML = e.innerHTML : "cssText" === i ? n.styleSheet ? n.styleSheet.cssText = e.cssText : n.appendChild(document.createTextNode(e.cssText)) : n.setAttribute(i, void 0 === e[i] ? "" : e[i]));
        n.setAttribute("data-rh", "true"), o.some(function(t, e) {
            return r = e, n.isEqualNode(t);
        }) ? o.splice(r, 1) : a.push(n);
    }), o.forEach(function(t) {
        return t.parentNode.removeChild(t);
    }), a.forEach(function(t) {
        return n.appendChild(t);
    }), {
        oldTags: o,
        newTags: a
    };
}, $3de8bcaad58a651a$var$B = function(t, e) {
    var r = document.getElementsByTagName(t)[0];
    if (r) {
        for(var n = r.getAttribute("data-rh"), i = n ? n.split(",") : [], o = [].concat(i), a = Object.keys(e), s = 0; s < a.length; s += 1){
            var c = a[s], u = e[c] || "";
            r.getAttribute(c) !== u && r.setAttribute(c, u), -1 === i.indexOf(c) && i.push(c);
            var l = o.indexOf(c);
            -1 !== l && o.splice(l, 1);
        }
        for(var p = o.length - 1; p >= 0; p -= 1)r.removeAttribute(o[p]);
        i.length === o.length ? r.removeAttribute("data-rh") : r.getAttribute("data-rh") !== a.join(",") && r.setAttribute("data-rh", a.join(","));
    }
}, $3de8bcaad58a651a$var$K = function(t, e) {
    var r = t.baseTag, n = t.htmlAttributes, i = t.linkTags, o = t.metaTags, a = t.noscriptTags, s = t.onChangeClientState, c = t.scriptTags, u = t.styleTags, p = t.title, f = t.titleAttributes;
    $3de8bcaad58a651a$var$B($3de8bcaad58a651a$var$l.BODY, t.bodyAttributes), $3de8bcaad58a651a$var$B($3de8bcaad58a651a$var$l.HTML, n), function(t, e) {
        void 0 !== t && document.title !== t && (document.title = $3de8bcaad58a651a$var$S(t)), $3de8bcaad58a651a$var$B($3de8bcaad58a651a$var$l.TITLE, e);
    }(p, f);
    var d = {
        baseTag: $3de8bcaad58a651a$var$Y($3de8bcaad58a651a$var$l.BASE, r),
        linkTags: $3de8bcaad58a651a$var$Y($3de8bcaad58a651a$var$l.LINK, i),
        metaTags: $3de8bcaad58a651a$var$Y($3de8bcaad58a651a$var$l.META, o),
        noscriptTags: $3de8bcaad58a651a$var$Y($3de8bcaad58a651a$var$l.NOSCRIPT, a),
        scriptTags: $3de8bcaad58a651a$var$Y($3de8bcaad58a651a$var$l.SCRIPT, c),
        styleTags: $3de8bcaad58a651a$var$Y($3de8bcaad58a651a$var$l.STYLE, u)
    }, h = {}, m = {};
    Object.keys(d).forEach(function(t) {
        var e = d[t], r = e.newTags, n = e.oldTags;
        r.length && (h[t] = r), n.length && (m[t] = d[t].oldTags);
    }), e && e(), s(t, h, m);
}, $3de8bcaad58a651a$var$_ = null, $3de8bcaad58a651a$var$z = /*#__PURE__*/ function(t) {
    function e() {
        for(var e, r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
        return (e = t.call.apply(t, [
            this
        ].concat(n)) || this).rendered = !1, e;
    }
    $3de8bcaad58a651a$var$s(e, t);
    var r = e.prototype;
    return r.shouldComponentUpdate = function(t) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($agBrw)))(t, this.props);
    }, r.componentDidUpdate = function() {
        this.emitChange();
    }, r.componentWillUnmount = function() {
        this.props.context.helmetInstances.remove(this), this.emitChange();
    }, r.emitChange = function() {
        var t, e, r = this.props.context, n = r.setHelmet, i = null, o = (t = r.helmetInstances.get().map(function(t) {
            var e = $3de8bcaad58a651a$var$a({}, t.props);
            return delete e.context, e;
        }), {
            baseTag: $3de8bcaad58a651a$var$A([
                "href"
            ], t),
            bodyAttributes: $3de8bcaad58a651a$var$v("bodyAttributes", t),
            defer: $3de8bcaad58a651a$var$T(t, "defer"),
            encode: $3de8bcaad58a651a$var$T(t, "encodeSpecialCharacters"),
            htmlAttributes: $3de8bcaad58a651a$var$v("htmlAttributes", t),
            linkTags: $3de8bcaad58a651a$var$C($3de8bcaad58a651a$var$l.LINK, [
                "rel",
                "href"
            ], t),
            metaTags: $3de8bcaad58a651a$var$C($3de8bcaad58a651a$var$l.META, [
                "name",
                "charset",
                "http-equiv",
                "property",
                "itemprop"
            ], t),
            noscriptTags: $3de8bcaad58a651a$var$C($3de8bcaad58a651a$var$l.NOSCRIPT, [
                "innerHTML"
            ], t),
            onChangeClientState: $3de8bcaad58a651a$var$b(t),
            scriptTags: $3de8bcaad58a651a$var$C($3de8bcaad58a651a$var$l.SCRIPT, [
                "src",
                "innerHTML"
            ], t),
            styleTags: $3de8bcaad58a651a$var$C($3de8bcaad58a651a$var$l.STYLE, [
                "cssText"
            ], t),
            title: $3de8bcaad58a651a$var$g(t),
            titleAttributes: $3de8bcaad58a651a$var$v("titleAttributes", t),
            prioritizeSeoTags: $3de8bcaad58a651a$var$O(t, "prioritizeSeoTags")
        });
        $3de8bcaad58a651a$export$4719288a8f5f7e71.canUseDOM ? (e = o, $3de8bcaad58a651a$var$_ && cancelAnimationFrame($3de8bcaad58a651a$var$_), e.defer ? $3de8bcaad58a651a$var$_ = requestAnimationFrame(function() {
            $3de8bcaad58a651a$var$K(e, function() {
                $3de8bcaad58a651a$var$_ = null;
            });
        }) : ($3de8bcaad58a651a$var$K(e), $3de8bcaad58a651a$var$_ = null)) : $3de8bcaad58a651a$var$k && (i = $3de8bcaad58a651a$var$k(o)), n(i);
    }, r.init = function() {
        this.rendered || (this.rendered = !0, this.props.context.helmetInstances.add(this), this.emitChange());
    }, r.render = function() {
        return this.init(), null;
    }, e;
}((0, $dTCkE.Component));
$3de8bcaad58a651a$var$z.propTypes = {
    context: $3de8bcaad58a651a$var$D.isRequired
}, $3de8bcaad58a651a$var$z.displayName = "HelmetDispatcher";
var $3de8bcaad58a651a$var$F = [
    "children"
], $3de8bcaad58a651a$var$G = [
    "children"
], $3de8bcaad58a651a$export$dcef8f9bb9a41431 = /*#__PURE__*/ function(e) {
    function r() {
        return e.apply(this, arguments) || this;
    }
    $3de8bcaad58a651a$var$s(r, e);
    var o = r.prototype;
    return o.shouldComponentUpdate = function(t) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($lyBMc)))($3de8bcaad58a651a$var$I(this.props, "helmetData"), $3de8bcaad58a651a$var$I(t, "helmetData"));
    }, o.mapNestedChildrenToProps = function(t, e) {
        if (!e) return null;
        switch(t.type){
            case $3de8bcaad58a651a$var$l.SCRIPT:
            case $3de8bcaad58a651a$var$l.NOSCRIPT:
                return {
                    innerHTML: e
                };
            case $3de8bcaad58a651a$var$l.STYLE:
                return {
                    cssText: e
                };
            default:
                throw new Error("<" + t.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        }
    }, o.flattenArrayTypeChildren = function(t) {
        var e, r = t.child, n = t.arrayTypeChildren;
        return $3de8bcaad58a651a$var$a({}, n, ((e = {})[r.type] = [].concat(n[r.type] || [], [
            $3de8bcaad58a651a$var$a({}, t.newChildProps, this.mapNestedChildrenToProps(r, t.nestedChildren))
        ]), e));
    }, o.mapObjectTypeChildren = function(t) {
        var e, r, n = t.child, i = t.newProps, o = t.newChildProps, s = t.nestedChildren;
        switch(n.type){
            case $3de8bcaad58a651a$var$l.TITLE:
                return $3de8bcaad58a651a$var$a({}, i, ((e = {})[n.type] = s, e.titleAttributes = $3de8bcaad58a651a$var$a({}, o), e));
            case $3de8bcaad58a651a$var$l.BODY:
                return $3de8bcaad58a651a$var$a({}, i, {
                    bodyAttributes: $3de8bcaad58a651a$var$a({}, o)
                });
            case $3de8bcaad58a651a$var$l.HTML:
                return $3de8bcaad58a651a$var$a({}, i, {
                    htmlAttributes: $3de8bcaad58a651a$var$a({}, o)
                });
            default:
                return $3de8bcaad58a651a$var$a({}, i, ((r = {})[n.type] = $3de8bcaad58a651a$var$a({}, o), r));
        }
    }, o.mapArrayTypeChildrenToProps = function(t, e) {
        var r = $3de8bcaad58a651a$var$a({}, e);
        return Object.keys(t).forEach(function(e) {
            var n;
            r = $3de8bcaad58a651a$var$a({}, r, ((n = {})[e] = t[e], n));
        }), r;
    }, o.warnOnInvalidChildren = function(t, e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gQQaU)))($3de8bcaad58a651a$var$h.some(function(e) {
            return t.type === e;
        }), "function" == typeof t.type ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : "Only elements types " + $3de8bcaad58a651a$var$h.join(", ") + " are allowed. Helmet does not support rendering <" + t.type + "> elements. Refer to our API for more information."), (0, (/*@__PURE__*/$parcel$interopDefault($gQQaU)))(!e || "string" == typeof e || Array.isArray(e) && !e.some(function(t) {
            return "string" != typeof t;
        }), "Helmet expects a string as a child of <" + t.type + ">. Did you forget to wrap your children in braces? ( <" + t.type + ">{``}</" + t.type + "> ) Refer to our API for more information."), !0;
    }, o.mapChildrenToProps = function(e, r) {
        var n = this, i = {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).Children.forEach(e, function(t) {
            if (t && t.props) {
                var e = t.props, o = e.children, a = $3de8bcaad58a651a$var$u(e, $3de8bcaad58a651a$var$F), s = Object.keys(a).reduce(function(t, e) {
                    return t[$3de8bcaad58a651a$var$y[e] || e] = a[e], t;
                }, {}), c = t.type;
                switch("symbol" == typeof c ? c = c.toString() : n.warnOnInvalidChildren(t, o), c){
                    case $3de8bcaad58a651a$var$l.FRAGMENT:
                        r = n.mapChildrenToProps(o, r);
                        break;
                    case $3de8bcaad58a651a$var$l.LINK:
                    case $3de8bcaad58a651a$var$l.META:
                    case $3de8bcaad58a651a$var$l.NOSCRIPT:
                    case $3de8bcaad58a651a$var$l.SCRIPT:
                    case $3de8bcaad58a651a$var$l.STYLE:
                        i = n.flattenArrayTypeChildren({
                            child: t,
                            arrayTypeChildren: i,
                            newChildProps: s,
                            nestedChildren: o
                        });
                        break;
                    default:
                        r = n.mapObjectTypeChildren({
                            child: t,
                            newProps: r,
                            newChildProps: s,
                            nestedChildren: o
                        });
                }
            }
        }), this.mapArrayTypeChildrenToProps(i, r);
    }, o.render = function() {
        var e = this.props, r = e.children, n = $3de8bcaad58a651a$var$u(e, $3de8bcaad58a651a$var$G), i = $3de8bcaad58a651a$var$a({}, n), o = n.helmetData;
        return r && (i = this.mapChildrenToProps(r, i)), !o || o instanceof $3de8bcaad58a651a$export$a9cf6990c9c7feb9 || (o = new $3de8bcaad58a651a$export$a9cf6990c9c7feb9(o.context, o.instances)), o ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).createElement($3de8bcaad58a651a$var$z, $3de8bcaad58a651a$var$a({}, i, {
            context: o.value,
            helmetData: void 0
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).createElement($3de8bcaad58a651a$var$R.Consumer, null, function(e) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).createElement($3de8bcaad58a651a$var$z, $3de8bcaad58a651a$var$a({}, i, {
                context: e
            }));
        });
    }, r;
}((0, $dTCkE.Component));
$3de8bcaad58a651a$export$dcef8f9bb9a41431.propTypes = {
    base: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).object,
    bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).node
    ]),
    defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).string,
    defer: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).bool,
    encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).bool,
    htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).object,
    link: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).object),
    meta: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).object),
    noscript: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).object),
    onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).func,
    script: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).object),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).object),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).string,
    titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).object,
    titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).string,
    prioritizeSeoTags: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).bool,
    helmetData: (0, (/*@__PURE__*/$parcel$interopDefault($34sMR))).object
}, $3de8bcaad58a651a$export$dcef8f9bb9a41431.defaultProps = {
    defer: !0,
    encodeSpecialCharacters: !0,
    prioritizeSeoTags: !1
}, $3de8bcaad58a651a$export$dcef8f9bb9a41431.displayName = "Helmet";

});
parcelRegister("34sMR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $23c81354780d5bc0$var$ReactIs, $23c81354780d5bc0$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("iKCB7"))();

});
parcelRegister("iKCB7", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $dDf3s = parcelRequire("dDf3s");
function $da6a768f591f068e$var$emptyFunction() {}
function $da6a768f591f068e$var$emptyFunctionWithReset() {}
$da6a768f591f068e$var$emptyFunctionWithReset.resetWarningCache = $da6a768f591f068e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $dDf3s) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $da6a768f591f068e$var$emptyFunctionWithReset,
        resetWarningCache: $da6a768f591f068e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("dDf3s", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $9eca98714df17e56$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $9eca98714df17e56$var$ReactPropTypesSecret;

});



parcelRegister("lyBMc", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $fb1a138ca69918d1$var$hasElementType = typeof Element !== "undefined";
var $fb1a138ca69918d1$var$hasMap = typeof Map === "function";
var $fb1a138ca69918d1$var$hasSet = typeof Set === "function";
var $fb1a138ca69918d1$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $fb1a138ca69918d1$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$fb1a138ca69918d1$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($fb1a138ca69918d1$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$fb1a138ca69918d1$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($fb1a138ca69918d1$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($fb1a138ca69918d1$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($fb1a138ca69918d1$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$fb1a138ca69918d1$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $fb1a138ca69918d1$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("gQQaU", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $c449f985c18166ba$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $c449f985c18166ba$var$invariant;

});

parcelRegister("agBrw", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});


})();
//# sourceMappingURL=ObjectPage.bb69ce9b.js.map
